import React, { useState } from 'react';
import { profileApi } from '../../../services/api';
import AddEditModal from '../shared/AddEditModal';
import ItemCard from '../shared/ItemCard';

const skillFields = [
    { name: 'category', label: 'الفئة', type: 'select', required: true, options: [
        { value: 'frontend', label: 'تطوير الواجهات' },
        { value: 'backend', label: 'تطوير الخوادم' },
        { value: 'database', label: 'قواعد البيانات' },
        { value: 'mobile', label: 'تطوير الجوال' },
        { value: 'devops', label: 'DevOps والأدوات' },
        { value: 'testing', label: 'الاختبار وضمان الجودة' },
        { value: 'cloud', label: 'المنصات السحابية' },
        { value: 'ai_ml', label: 'أدوات الذكاء الاصطناعي' },
        { value: 'tools', label: 'أدوات التطوير' },
        { value: 'sap', label: 'مهارات SAP' },
        { value: 'methodologies', label: 'المنهجيات' },
        { value: 'soft_skills', label: 'المهارات الشخصية' },
        { value: 'other', label: 'أخرى' }
    ]},
    { name: 'name', label: 'اسم المهارة', type: 'text', required: true, placeholder: 'React.js' },
    { name: 'proficiency_text', label: 'مستوى الإتقان', type: 'select', options: [
        { value: 'Advanced', label: 'متقدم - مهارات قوية، استخدام يومي' },
        { value: 'Proficient', label: 'متمكن - معرفة عملية جيدة' },
        { value: 'Familiar', label: 'ملم - فهم أساسي' },
        { value: 'Learning', label: 'أتعلم - أدرس حالياً' },
        { value: 'Planned', label: 'مخطط - تعلم مستقبلي' }
    ]},
    { name: 'notes', label: 'ملاحظات (اختياري)', type: 'text', placeholder: 'مثال: 5+ مشاريع' },
    { name: 'description', label: 'الوصف (للمهارات الشخصية)', type: 'textarea', placeholder: 'صف كيف تستخدم هذه المهارة...' }
];

export default function Skills({ profile, onRefresh }) {
    const [showModal, setShowModal] = useState(false);
    const [editItem, setEditItem] = useState(null);
    const [loading, setLoading] = useState(false);

    const skills = profile?.skills || [];

    const handleAdd = () => {
        setEditItem(null);
        setShowModal(true);
    };

    const handleEdit = (item) => {
        setEditItem(item);
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        if (!window.confirm('هل أنت متأكد من حذف هذه المهارة؟')) return;
        setLoading(true);
        try {
            await profileApi.deleteSkill(id);
            onRefresh('skills');
        } catch (err) {
            alert('فشل في حذف المهارة');
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async (data) => {
        setLoading(true);
        try {
            if (editItem) {
                await profileApi.updateSkill(editItem.id, data);
            } else {
                await profileApi.addSkill(data);
            }
            setShowModal(false);
            onRefresh('skills');
        } catch (err) {
            alert('فشل في حفظ المهارة');
        } finally {
            setLoading(false);
        }
    };

    // Group skills by category
    const groupedSkills = skills.reduce((acc, skill) => {
        const category = skill.category || 'other';
        if (!acc[category]) {
            acc[category] = [];
        }
        acc[category].push(skill);
        return acc;
    }, {});

    const categoryLabels = {
        frontend: 'تطوير الواجهات',
        backend: 'تطوير الخوادم',
        database: 'قواعد البيانات',
        mobile: 'تطوير الجوال',
        devops: 'DevOps والأدوات',
        testing: 'الاختبار وضمان الجودة',
        cloud: 'المنصات السحابية',
        ai_ml: 'أدوات الذكاء الاصطناعي',
        tools: 'أدوات التطوير',
        sap: 'مهارات SAP',
        methodologies: 'المنهجيات',
        soft_skills: 'المهارات الشخصية',
        other: 'أخرى'
    };

    return (
        <div className="section-container">
            <div className="section-header">
                <h2 className="section-title">المهارات</h2>
                <button className="add-button" onClick={handleAdd}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                    إضافة مهارة
                </button>
            </div>

            {skills.length === 0 ? (
                <div className="empty-state">
                    <div className="empty-state-icon">
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                            <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
                        </svg>
                    </div>
                    <h3 className="empty-state-title">لا توجد مهارات بعد</h3>
                    <p className="empty-state-description">أضف مهاراتك التقنية والمهنية</p>
                    <button className="add-button" onClick={handleAdd}>أضف مهارتك الأولى</button>
                </div>
            ) : (
                <div className="skills-by-category">
                    {Object.entries(groupedSkills).map(([category, categorySkills]) => (
                        <div key={category} className="skill-category-section">
                            <h3 className="category-title">{categoryLabels[category] || category}</h3>
                            <div className="items-grid">
                                {categorySkills.map((skill) => (
                                    <ItemCard
                                        key={skill.id}
                                        title={skill.name}
                                        subtitle={skill.proficiency_text || 'متمكن'}
                                        details={skill.notes}
                                        onEdit={() => handleEdit(skill)}
                                        onDelete={() => handleDelete(skill.id)}
                                    />
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {showModal && (
                <AddEditModal
                    title={editItem ? 'تعديل المهارة' : 'إضافة مهارة'}
                    fields={skillFields}
                    initialData={editItem || { category: 'frontend', proficiency_text: 'Proficient' }}
                    onSave={handleSave}
                    onClose={() => setShowModal(false)}
                    loading={loading}
                />
            )}
        </div>
    );
}
